// extracted by mini-css-extract-plugin
module.exports = {"container":"_1lERxgf","header":"_2xJZyHS","gameList":"_1R7obt4"};